import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./pages/App";
import configureStore from "./configureStore";
import { ThemeProvider } from "@mui/material";
import { errorHandler } from "./errorHandler";
import { ServiceWorkerProvider } from "./components/CustomHooks/useServiceWorker";
import theme from "./theme";
import reportWebVitals from "./reportWebVitals";

const store = configureStore();
const rootElement = document.getElementById("root");
// in case broken code delivered
errorHandler();

const root = createRoot(rootElement);
root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <ServiceWorkerProvider>
        <App />
      </ServiceWorkerProvider>
    </Provider>
  </ThemeProvider>
);

// This line is to start measuring performance in the app.
reportWebVitals(console.log);
